/**
 * Button Tokens
 */

import { corners, space, accent, text, platform } from "../semantic";

export const button = {
  default: {
    bg: platform.buttonBg,
    text: platform.buttonText,
    radius: corners.button,
    padding: `${space.insetLg} ${space.insetXl}`,
  },
  destructive: {
    bg: accent.danger,
    text: text.onAccent,
    radius: corners.button,
    padding: `${space.insetLg} ${space.insetXl}`,
  },
  ghost: {
    bg: "transparent",
    text: text.muted,
    radius: corners.button,
    padding: `${space.insetLg} ${space.insetXl}`,
  },
  disabled: { opacity: 0.5 },
  pressed: { scale: 0.98 },
} as const;
